module.exports = __webpack_public_path__ + "img/customer-database.fcd75add.png";